import { platformApi } from '../util/platformApi';

export type AppNotification = {
  id: string;
  workspaceId: string;
  orgId?: string;
  type: 'budget_alert' | 'budget_cap_reached';
  title: string;
  message: string;
  severity: 'warning' | 'danger';
  createdAt: number;
  metadata?: Record<string, unknown>;
};

export async function getNotifications(
  workspaceId: string,
  workspaceIds: string[],
): Promise<AppNotification[]> {
  const result = await platformApi({
    workspaceId,
    platformType: 'recap',
    apiSubset: 'notifications',
    operation: 'getNotifications',
    data: { workspaceIds: workspaceIds.join(',') },
  });
  return result?.notifications ?? [];
}

export async function markNotificationRead(
  workspaceId: string,
  notificationId: string,
): Promise<void> {
  await platformApi({
    workspaceId,
    platformType: 'recap',
    apiSubset: 'notifications',
    operation: 'markRead',
    data: { notificationId },
  });
}
